<div>
  <button nz-button [nzType]="data.mainType" class="mr-4">{{ data.mainTitle }}</button>
  <a href="javascript: void(0);" class="vb__utils__link">
    {{ data.additionalTitle }}
  </a>
</div>